<template>
  <div>
    <label :class="labelClass" class="p-float-label label hk-grotest-medium"
      >{{ label }}<span v-if="required" class="required">*</span></label
    >
    <div class="input-wrapper">
      <span v-if="icon" class="icon-container"><i :class="icon" class="icons field" /></span>
      <InputText
        class="input-field md:col-6"
        :placeholder="placeholder"
        :class="inValid ? 'p-invalid ' + inputClass : input"
        :type="type"
        v-model="value"
        :disabled="disable"
        min="0"
        :style="{
          height: `${height}`,
          width: `${width}`,
          border: `1px solid ${color} !important`,
          color: `${color}`,
        }"
        @input="onInput"
        @keydown="keyDown"
      />
    </div>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext';
export default {
  name: 'TextField',
  props: [
    'icon',
    'placeholder',
    'label',
    'height',
    'width',
    'border',
    'color',
    'type',
    'labelClass',
    'value',
    'errorMessages',
    'required',
    'inputClass',
    'disable',
    'inValid',
  ],
  methods: {
    onInput({ target }) {
      this.$emit('onInput', target.value);
    },
    keyDown(value) {
      if (this.type == 'number') {
        let invalidChars = ['-', '+', 'e', '.'];
        if (invalidChars.includes(value.key)) {
          value.preventDefault();
        }
      }
    },
  },
  components: { InputText },
  watch: {
    editValue() {
      this.$emit('change', this.editValue);
    },
  },
  mounted() {
    this.editValue = this.value;
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';
.input-wrapper {
  display: flex;
  align-items: center;
}
.input-field {
  border-color: unset;
  outline: 0 none;
  outline-offset: 0;
  box-shadow: unset !important;
  border-radius: unset !important;
}

.icons {
  font-weight: bold !important;
  height: 100%;
  font-size: 1.2rem;
  padding: 10px;
  min-width: 40px;
  // border-right: 1px solid #ced4da;
  border: 1px solid #ced4da;
  margin-top: 1rem;
}

.p-inputtext {
  border: 1px solid rgba(2, 0, 56, 0.15);
  border-radius: 4px !important;
  font-family: HK-medium !important;
}
:deep(.p-inputtext) {
  font-family: HK-medium !important;
}
// .p-inputtext:enabled:focus {
//   border-color: rgba(2, 0, 56, 0.15);
//   border: 1px solid rgba(2, 0, 56, 0.3);
//   box-shadow: unset;
// }
.p-inputtext:enabled:hover {
  border-color: rgba(2, 0, 56, 0.15);
  border: 1px solid rgba(100, 97, 170, 0.3);
  box-shadow: unset;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.label {
  color: $secondary-color;
}
.p-inputtext:enabled:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.1rem rgba(2, 0, 56, 0.3) !important;
  border-color: rgba(2, 0, 56, 0.15);
}
</style>
